import { render, staticRenderFns } from "./BetSlipModal.vue?vue&type=template&id=55877c96&scoped=true&"
import script from "./BetSlipModal.vue?vue&type=script&lang=js&"
export * from "./BetSlipModal.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipModal.vue?vue&type=style&index=0&id=55877c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55877c96",
  null
  
)

export default component.exports